/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface RiskIndicatorType
 */
export interface RiskIndicatorType {
  /**
   *
   * @type {number}
   * @memberof RiskIndicatorType
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof RiskIndicatorType
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof RiskIndicatorType
   */
  readonly riskMetrics: string;
}

/**
 * Check if a given object implements the RiskIndicatorType interface.
 */
export function instanceOfRiskIndicatorType(value: object): value is RiskIndicatorType {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('riskMetrics' in value) || value['riskMetrics'] === undefined) return false;
  return true;
}

export function RiskIndicatorTypeFromJSON(json: any): RiskIndicatorType {
  return RiskIndicatorTypeFromJSONTyped(json, false);
}

export function RiskIndicatorTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskIndicatorType {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    riskMetrics: json['risk_metrics'],
  };
}

export function RiskIndicatorTypeToJSON(value?: Omit<RiskIndicatorType, 'id' | 'riskMetrics'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
  };
}
